import React from 'react'
import { useTranslation } from 'react-i18next'
import DocumentService from 'routes/Declaration/services/document.service'
import messages from 'messages/error-messages'
import { useFetchTransitOperationLogDetails } from '../api/fetchTransitOperationLogDetails'
import { FunctionalError } from '../models/types'

// SK's Neprijaté: CEP refused the signed submission and gives no reason of its own.
const CEP_REJECTION = 'CEP rejection'

interface LogDetailsRowProps {
  logId: number
  messageContext: string | undefined
  colSpan: number
}

function LogDetailsRow({ logId, messageContext, colSpan }: Readonly<LogDetailsRowProps>) {
  const { t } = useTranslation()
  const { data: functionalErrors, isLoading } = useFetchTransitOperationLogDetails(logId, true)

  const describe = (functionalError: FunctionalError) => {
    if (functionalError.description) {
      return functionalError.description
    }
    if (messageContext === CEP_REJECTION) {
      return t('transitOperation.submission.cepNotAccepted')
    }
    return messages.errors.find((itm) => itm.code === functionalError.reason)?.en
  }

  if (isLoading) {
    return (
      <tr className="log-row">
        <td colSpan={colSpan} className="log-row__messages first last">
          <i className="fal fa-spinner fa-spin me-1" />
        </td>
      </tr>
    )
  }

  if (!functionalErrors || functionalErrors.length === 0) {
    return null
  }

  return (
    <>
      {functionalErrors.map((functionalError, j) => (
        // eslint-disable-next-line react/no-array-index-key
        <tr className="log-row" key={`${logId}-${j}`}>
          <td
            colSpan={colSpan}
            className={`log-row__messages ${
              // eslint-disable-next-line no-nested-ternary
              (functionalErrors.length <= 1) ? 'first last'
              // eslint-disable-next-line no-nested-ternary
                : (j === 0) ? 'first'
                  : (j === functionalErrors.length - 1) ? 'last'
                    : ''}`}
          >
            <div className="log-row__messages-container">
              <div className="log-row__messages-column w-auto">
                <h5>Type</h5>
                <span>
                  {functionalError.type}
                </span>
              </div>
              <div className="log-row__messages-column w-auto">
                <h5>Reason</h5>
                {(functionalError.type === 'DmeDocumentInfoMessage' || functionalError.type === 'FILE') ? (
                  <button
                    type="button"
                    className="download-link"
                    onClick={() => DocumentService.saveBlob(null, functionalError.reason, 'url', functionalError.originalAttributeValue)}
                  >
                    {t('buttons.downloadPdf')}
                  </button>
                ) : <span>{functionalError.reason}</span>}
              </div>
              <div className="log-row__messages-column">
                <h5>Pointer</h5>
                <span>
                  {functionalError.pointer}
                </span>
              </div>
              <div className="log-row__messages-column">
                <h5>Value</h5>
                <span>
                  {functionalError.originalAttributeValue}
                </span>
              </div>
              <div className="log-row__messages-column">
                <h5>Description</h5>
                <span>
                  {describe(functionalError)}
                </span>
              </div>
            </div>
          </td>
        </tr>
      ))}
    </>
  )
}

export default LogDetailsRow
